module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/aneta-dunn-31448f7ff4df98d648f132ab6e42a476.webp";